import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeSwiperSobre = () => {
    document.addEventListener("DOMContentLoaded", function () {
        new Swiper("#swiper-sobre", {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 24,
            speed: 600,
            autoHeight: true,
            loop: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-sobre-button-next",
                prevEl: ".swiper-sobre-button-prev",
            },
            pagination: {
                el: "#swiper-sobre-pagination",
                type: "bullets",
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}"></span>`;
                },
            },
            breakpoints: {
                1024: { // Telas maiores ou iguais a 1024px
                    slidesPerView: 1,
                },
                0: { // Para telas menores que 1024px
                    slidesPerView: 1,
                }
            }
        });
    });
};

export default initializeSwiperSobre;
